// extracted by mini-css-extract-plugin
export var optionGrid = "_53-7";
export var optionList = "_53-6";
export var questionsBlock = "_53-9";
export var spacer = "_53-5";
export var stepCenteredContent = "_53-3";
export var stepInner = "_53-0";
export var stepInnerFullWidth = "_53-1";
export var stepInnerLockScroll = "_53-2";
export var stepTransitionFrame = "_53-4";
export var welcomeBlock = "_53-8";